// extracted by mini-css-extract-plugin
module.exports = {"reservedSpace":"PersonalizationContainer_reservedSpace__O_RNt"};